import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKgQuote1 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M1 12h8v10H1V12Zm0 0C1 5 2.75 3.344 6 2m8 10h8m-8 0v10h4m-4-10c0-7 1.75-8.656 5-10m1.7 14.4 1.75-1.4h.35v7"
	})
});
export default SvgKgQuote1;
